import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Label
} from 'reactstrap';

import FormBuilder from './forms/formBuilder';
import { required, emailAddress } from './forms/validation'

import { formValueSelector, change } from "redux-form"; // ES6
import { connect } from "react-redux";


import { API_ENDPOINT } from '../constants'
import Checkbox from './forms/fields/checkbox';
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class ConsentModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            groupObj: null,
            consentGranted: true
        }
    }

    componentDidMount() {

        this.getGroupId()

    }

    componentDidUpdate(prevProps) {

    }

    update = (data) => {
        fetch(API_ENDPOINT + '/users/account/update', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(parseJSON).then(({ result, status }) => {
            if (result.error) {
                this.setState({ error: result.error.translate(this.props.lang) })
            } else {
                this.props.verifyUser();
            }

        })


    }
    getGroupId = () => {
        if (typeof window != 'undefined' && localStorage.groupAlias) {


            fetch(API_ENDPOINT + "/data/clinic-group/info", {
                method: "POST",
                headers: {
                    Authorization:
                        typeof localStorage !== "undefined"
                            ? `Bearer ${localStorage.getItem("authToken")}`
                            : null,
                    "content-type": "application/json",
                },
                body: JSON.stringify({ alias: localStorage.groupAlias }),
            }).then(parseJSON).then(({ result, status }) => {
                if (result && result._id) {
                    this.setState({ groupObj: result })
                }
            });
        }

    }

    render() {
        const { groupObj } = this.state

        return (
            <Modal isOpen={this.props.journalConsentModal} size='lg' centered zIndex={1060}>
                <ModalHeader style={{ justifyContent: 'center' }}>
                    <h6>{"Consent for Data Sharing".translate(this.props.lang)}</h6>
                </ModalHeader>
                <ModalBody className="bankid-modal privacy-policy-modal-body">
                    <p>{"Your data may be securely shared with authorized third parties through the journal system for service and record-keeping purposes".translate(this.props.lang)}</p>
                    <Checkbox
                        onChange={(e) => {

                            this.setState({
                                consentGranted: e.target.checked
                            })
                        }}
                        checked={this.state.consentGranted}
                        label={"I give my consent for my data to be shared with other parties via the journal system in accordance with applicable data protection laws".translate(this.props.lang)}
                        style={{ marginBottom: 10 }}
                    />
                </ModalBody>
                <ModalFooter className="buttons-right-blue">
                    <Button color="primary" className='continue-btn' onClick={() => {

                        let isJournalConsentActive = this.props.uData.isJournalConsentActive ? this.props.uData.isJournalConsentActive : {}
                        if (groupObj && groupObj._id) {
                            isJournalConsentActive[groupObj._id] = {
                                isActive: this.state.consentGranted,
                                time: Math.floor(new Date().getTime() / 1000)
                            }
                        }
                        this.update({ isJournalConsentActive })
                    }}>{'Continue'.translate(this.props.lang)}</Button>
                </ModalFooter>
            </Modal >
        )
    }
}

// const selector2 = formValueSelector("form");

export default connect(
    (state) => {
        return {
        };
    },
    {

    }
)(ConsentModal);